import { SelectItem } from "primeng/api";

export const BUSINESS_SEGMENT_OPTIONS: SelectItem[] = [
    { label: 'Business Viewing', value: 'Business' },
    { label: 'Private Viewing', value: 'Private' },
    { label: 'Public Viewing', value: 'Public' },
];

export const BUSINESS_INTERNET_PROVIDER_OPTIONS: SelectItem[] = [
    { label: 'AT&T', value: 'AT&T' },
    { label: 'Allo Fiber', value: 'AlloFiber'},
    { label: 'Consolidated', value: 'Consolidated' },
    { label: 'Charter', value: 'Charter' },
    { label: 'Earthlink', value: 'Earthlink' },
    { label: 'Frontier', value: 'Frontier' },
    { label: 'Windstream/Kinetic', value: 'Windstream/Kinetic' },
    { label: 'Ziply', value: 'Ziply' },
    { label: 'HughesNet', value: 'HughesNet' },
    { label: 'Altice', value: 'Altice' },
    { label: 'WOW!', value: 'WOW!' },
    { label: 'Brightspeed', value: 'Brightspeed' },
    { label: 'Alta fiber', value: 'Alta fiber' },
    { label: 'Viasat', value: 'Viasat' },
    { label: 'Hawaiian Telecom', value: 'Hawaiian Telecom' },
    { label: 'Century Link/Lumen/Quantum Fiber', value: 'Century Link/Lumen/Quantum Fiber' },
    { label: 'Metronet', value: 'Metronet' },
    { label: 'Starlink', value: 'Starlink' },
    { label: 'Other', value: 'Other' },
];

export const BUSINESS_INTERNET_SPEED_OPTIONS: SelectItem[] = [
    { label: '0-10 mbps (download)', value: '0-10' },
    { label: '11-100 mbps (download)', value: '11-100' },
    { label: '101-300 mbps (download)', value: '101-300' },
    { label: '301-500 mbps (download)', value: '301-500' },
    { label: '501-700 mbps (download)', value: '501-700' },
    { label: '701-900 mbps (download)', value: '701-900' },
    { label: '1+ GB (download)', value: '1GB' },
];

export const BUSINESS_TYPE_OPTIONS_SMB: SelectItem[] = [
    { label: 'Corporation', value: 'corp' },
    { label: 'Limited Liability Company (LLC)', value: 'llc' },
    { label: 'Sole Proprietorship', value: 'sole-prop' }
];

export const BUSINESS_TYPE_OPTIONS = [
    { label: 'Offshore Oil Rig', value: 'Offshore Oil Rig', accountType: ['OIL'] },
    { label: 'Onshore Oil Drill', value: 'Onshore Oil Drill', accountType: ['OIL'] },
    { label: 'State Government', value: 'State Government', accountType: ['FIR'] },
    { label: 'Federal Government', value: 'Federal Government', accountType: ['FIR'] },
    { label: 'Local Government', value: 'Local Government', accountType: ['FIR'] },
    { label: 'Home Based Business', value: 'Home Based Business', accountType: ['POL'] },
    { label: 'Manufacturing/Industrial', value: 'Manufacturing/Industrial', accountType: ['POL', 'FIR'] },
    { label: 'Professional Office', value: 'Professional Office', accountType: ['POL', 'FIR'] },
    { label: 'Bars and Lounges', value: 'Bars and Lounges', accountType: ['BAR', 'GOV'] },
    { label: 'Restaurants', value: 'Restaurants', accountType: ['BAR', 'GOV'] },
    { label: 'Quick Serve Restaurants', value: 'Quick Serve Restaurants', accountType: ['BAR', 'GOV'] },
    { label: 'Casino', value: 'Casino', accountType: ['BAR', 'GOV'] },
    { label: 'Entertainment/Recreation', value: 'Entertainment/Recreation', accountType: ['BAR', 'GOV'] },
    { label: 'Automotive Sales and Services', value: 'Automotive Sales and Services', accountType: ['HOS'] },
    { label: 'Beauty and Personal Care', value: 'Beauty and Personal Care', accountType: ['HOS'] },
    { label: 'Retail', value: 'Retail', accountType: ['HOS'] },
    { label: 'Religious Organizations', value: 'Religious Organizations', accountType: ['HOS'] },
    { label: 'Membership Club', value: 'Membership Club', accountType: ['HOS'] },
    { label: 'Medical Office', value: 'Medical Office', accountType: ['HOS'] },
    { label: 'Health and Fitness', value: 'Health and Fitness', accountType: ['HOS'] },
    { label: 'Banks and Financial Institutions', value: 'Banks and Financial Institutions', accountType: ['HOS'] },
    { label: 'Personal Services', value: 'Personal Services', accountType: ['HOS'] }
];

export const ACCOUNT_TYPE_OPTIONS = [
    { label: 'HOS - Retail and Waiting Rooms (General)', value: 'HOS', businessSegments: ['Business'] },
    { label: 'BVN - Retail and Waiting Rooms (National Accounts)', value: 'BVN', businessSegments: [] },
    { label: 'CNP - Commercial Non-Profit (National Accounts)', value: 'CNP', businessSegments: [] },
    { label: 'POL - Private Offices (General)', value: 'POL', businessSegments: ['Private'] },
    { label: 'FIR - Private Office (Government)', value: 'FIR', businessSegments: ['Private'] },
    { label: 'NPV - National Private Viewing (National Accounts)', value: 'NPV', businessSegments: [] },
    { label: 'OIL - Oil Rigs/Platforms', value: 'OIL', businessSegments: ['Private'] },
    { label: 'BAR - Bars and Restaurants (General)', value: 'BAR', businessSegments: ['Public'] },
    { label: 'BLK - Bars & Restaurants (National Accounts)', value: 'BLK', businessSegments: [] },
    { label: 'GOV - Bars & Restaurants (Government)', value: 'GOV', businessSegments: ['Public'] }
];

export const EVO_OPTIONS: SelectItem[] = [
    { label: 'None', value: 'None' },
    { label: '1-50', value: '1-50' },
    { label: '51-100', value: '51-100' },
    { label: '101-150', value: '101-150' },
    { label: '151-200', value: '151-200' },
    { label: '201-350', value: '201-350' },
    { label: '351-500', value: '351-500' },
    { label: '501-750', value: '501-750' },
    { label: '751-1000', value: '751-1000' },
    { label: '1001-1500', value: '1001-1500' },
    { label: '1501-2000', value: '1501-2000' },
    { label: '2001-5000', value: '2001-5000' },
    { label: '5001-10000', value: '5001-10000' },
    { label: '10001-99999', value: '10001-99999' }
];